import React from "react";
import { Route, Redirect } from "react-router-dom";
import _ from "lodash";
import Constants from "../AppConstants/Constants";

export default ({ component: C, props: cProps, ...rest }) => {
    return (
        <Route
            {...rest}
            render={props => {
                if (cProps.isAuthenticated) {
                    const { location } = props;
                    const routeArr = _.filter(location.pathname.split("/"), part => part.length > 0);
                    const route = routeArr[routeArr.length - 1];

                    if (`/${route}` === Constants.ENDPOINTS.CUSTOMER) {
                        return <Redirect to={Constants.ENDPOINTS.CUSTOMER_INFO} />;
                    }

                    return <C {...props} {...cProps} />;
                }

                return <Redirect to={`${Constants.ENDPOINTS.LOGIN}?returnUrl=${location.pathname}${location.search}`} />;
            }}
        />
    );
}